import React, { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import reducer, { initialState } from './reducer';
import actionsFactory from './reducer/actions';
import { Trek } from 'utils/analytics';

const initialContext = {
  state: initialState,
  actions: actionsFactory(() => { })
};

const ExperimentsContext = createContext(initialContext);
const useExperimentsContext = () => useContext(ExperimentsContext);

function ExperimentsContextProvider({ children }) {
  const [state, dispatcher] = useReducer(
    reducer,
    initialState,
  );
  
  const actions = useMemo(() => actionsFactory(dispatcher), [dispatcher]);
  const contextValue = { state, actions };

  useEffect(() => {
    actions.assignExperimentVariant('italianCitiesPricing');
    actions.assignExperimentVariant('localPicker');
    actions.assignExperimentVariant('roundedPriceCards');
  }, [actions]);

  return (
    <ExperimentsContext.Provider value={contextValue}>
      <Trek context={{ experiments: contextValue.state.experiments }}>
        {children}
      </Trek>
    </ExperimentsContext.Provider>
  );
}

export { useExperimentsContext, ExperimentsContextProvider };
